const ArrowDownGreen = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
    <path
      d="M16.0988 6.70125L10.0988 12.7012L10.0988 0L7.69875 0L7.69875 12.7012L1.69875 6.70125L0 8.39625L8.0475 16.4437C8.51625 16.9125 9.2775 16.9125 9.74625 16.4437L17.7938 8.39625L16.0988 6.70125Z"
      fill="#057A55"
    />
  </svg>
);

export default ArrowDownGreen;
